import { createStyledTheme } from "../theme.js";
import { createMUDSFluentTheme } from "../fluent/theme.js";
import { getResolvedAppearance, normalizeResolvedThemeResponse } from "./themeContract.js";

export function selectResolvedBrandingTheme(siteSettings, appearance) {
  const theme = normalizeResolvedThemeResponse(siteSettings);
  return getResolvedAppearance(theme, appearance || theme.effectiveConfig.appearance.default);
}

export function buildBrandingThemes(siteSettings, appearance) {
  const resolvedTheme = selectResolvedBrandingTheme(siteSettings, appearance);

  return {
    resolvedTheme,
    styledTheme: createStyledTheme(resolvedTheme),
    fluentTheme: createMUDSFluentTheme(resolvedTheme)
  };
}
